
export class Authentication {

    public static readonly userDataName: string = "userData";
    public static readonly token: string = "token";
    public static readonly customAvatarPrefix: string = "customAvatar:";

    public saveUserDataAuth(userDataAuth: any): void {
        try {
            localStorage.setItem(Authentication.userDataName, JSON.stringify(userDataAuth));
        } catch {
        }
    }

    public saveToken(token: string): void {
        localStorage.setItem(Authentication.token, "Bearer " + token);
    }

    public saveCustomAvatar(email: string, avatarDataUrl: string): void {
        if (!email) {
            return;
        }
        try {
            localStorage.setItem(Authentication.customAvatarPrefix + email.toLowerCase(), avatarDataUrl);
        } catch {
        }
    }

    public getCustomAvatar(email: string): string {
        if (!email) {
            return "";
        }
        return localStorage.getItem(Authentication.customAvatarPrefix + email.toLowerCase()) || "";
    }

    public getToken(): any {
        return localStorage.getItem(Authentication.token);
    }

    public getUserDataAuth(): any{
        let userData: any = null;
        userData = localStorage.getItem(Authentication.userDataName);
        return JSON.parse(userData);
    }

    public singout(): void {
        localStorage.clear();
    }

    public isLogin(): boolean {
        return this.getUserDataAuth() !== null;    
    }
}
